import React from "react";
import { Alert, Col, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckSquare, faSquare } from "@fortawesome/free-solid-svg-icons";
import { useWizard } from "./WizardContext";
import { useGuestContext } from "../../../../contexts/GuestContext";
import LanguageToggle from "../LanguageToggle";
import cuteMonk1 from "../../../../assets/img/baolinPrivate/cute_monk1.png";
import cuteMonk2 from "../../../../assets/img/baolinPrivate/cute_monk2.png";
import { getSessionLabel, groupLiangHuangSessions } from "../../../../config/liangHuang2026";

const Step2 = React.forwardRef((props, ref) => {
  const { sessionSelections, setSessionSelected } = useWizard();
  const { language } = useGuestContext();
  const [showError, setShowError] = React.useState(false);

  const validate = () => {
    const isValid = Object.values(sessionSelections).some(Boolean);
    setShowError(!isValid);
    return isValid;
  };

  React.useImperativeHandle(ref, () => ({ isValidated: validate }));

  const toggleSession = (field) => {
    setSessionSelected(field, !sessionSelections[field]);
    setShowError(false);
  };

  return (
    <div className="wizard-step" ref={ref}>
      <p className="text-center mb-2 font-weight-bold">
        <img src={cuteMonk1} alt="" width="40" className="mr-3" />
        {language === "English" ? "Select your sessions" : "選擇共修時段"}
        <img src={cuteMonk2} alt="" width="40" className="ml-3" />
      </p>
      <hr />
      <LanguageToggle />
      <hr />

      <Row>
        <Col md={{ span: 10, offset: 1 }}>
          <p className="font-weight-bold mb-2">
            {language === "English" ? "Select every session you plan to attend." : "請勾選所有您要參加的共修時段。"}
          </p>
          {showError && (
            <Alert variant="danger" className="py-2">
              {language === "English" ? "Select at least one session." : "請至少選擇一個共修時段"}
            </Alert>
          )}

          {groupLiangHuangSessions().map((group) => {
            const first = group.sessions[0];
            return (
              <section key={group.dateKey} className="border-bottom py-3">
                <div className="d-flex flex-wrap align-items-center mb-2">
                  <strong>{first.date[language]}</strong>
                  {(first.allDay || first.completion) && (
                    <div className="w-100 mt-1">
                      {first.allDay && (
                        <span className="badge badge-warning mr-2">
                          {language === "English" ? "All-day programme" : "全天共修"}
                        </span>
                      )}
                      {first.completion && (
                        <span className="badge badge-success">
                          {language === "English" ? "Completion ceremony" : "總圓滿大法會"}
                        </span>
                      )}
                    </div>
                  )}
                </div>

                {group.sessions.map((session) => {
                  const selected = Boolean(sessionSelections[session.field]);
                  return (
                    <button
                      key={session.field}
                      type="button"
                      aria-pressed={selected}
                      className="btn w-100 d-flex align-items-center text-left mb-2 px-3 py-3"
                      onClick={() => toggleSession(session.field)}
                      style={{
                        backgroundColor: selected ? "#fff4db" : "#ffffff",
                        border: `2px solid ${selected ? "#f0a43b" : "#ced4da"}`,
                        borderRadius: "6px",
                        boxShadow: selected ? "0 0 0 2px rgba(240, 164, 59, 0.18)" : "none",
                        color: "#212529",
                        whiteSpace: "normal",
                      }}
                    >
                      <FontAwesomeIcon
                        icon={selected ? faCheckSquare : faSquare}
                        className={`mr-3 ${selected ? "text-warning" : "text-secondary"}`}
                        size="lg"
                      />
                      <span className="font-weight-bold">{getSessionLabel(session, language)}</span>
                    </button>
                  );
                })}
              </section>
            );
          })}
        </Col>
      </Row>
    </div>
  );
});

export default Step2;
